export enum ApiCreateUserKnownErrorsEnum {
  EMAIL_ALREADY_USED = 'EMAIL_ALREADY_USED',
}
